module.exports = __webpack_public_path__ + "img/new-logo.b35e98b5.png";